import React, {Component} from 'react'
import { connect } from 'react-redux'

// import styles
import './viewsettings.scss'

// Actions
import { getViewSettings, saveViewSettings } from '../../../actions/settings'

// Components
import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Switch from '../../../shared/elements/switch'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Radio from '../../../shared/elements/radio'

// Utils
import { translation } from '../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../utils/auth'

class ViewSettings extends Component {

  constructor (props) {
    super(props)
    this.state = {
      ViewSetting: {
        ShopId: 0,
        DateOnOrder: false,
        TimeOnOrderList: true,
        NewOrdersGrouping: 0
      }
    }
    this.onChange = this.onChange.bind(this)
  }

  componentDidMount () {
    this.getViewSettings(this.props)
  }

  getViewSettings (props) {
    this.props.getViewSettings(this.props.auth.user.ShopId).then((res) => {
      this.setState({
        ViewSetting: res.data
      })
    }, (err) => {
      console.log(err)
    })
  }

  saveViewSetting (e) {
    let viewSetting = { ...this.state.ViewSetting }
    // update
    this.props.saveViewSettings(viewSetting).then((res) => {
      this.setState({
        ViewSetting: res.data
      })
      // Toastr
      // window.toastr.success(translation('15040'), translation('13424'))
      // console.log('dateOnOrder', this.state.ViewSetting.DateOnOrder)
    }, (err) => {
      if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
        let errors = err.response.data.Errors
        let errorText = ''
        errors.map((item) => {
          if (item.DictionaryKey !== 0) {
            errorText += '<br />' + translation(item.DictionaryKey)
          }
        })
        // Toastr
        window.toastr.error(translation(errorText), translation('216'))
      } else {
        // Toastr
        window.toastr.error(translation('910'), translation('216'))
      }
    })
  }

  onChange (e) {
    e.persist()
    let { name, value, checked, type } = e.target

    if (type === 'checkbox') {
      value = name === 'DateOnOrder' ? !checked : checked
    }

    this.setState({
      ViewSetting: {
        ...this.state.ViewSetting,
        [name]: value
      }
    }, () => {
      this.saveViewSetting()
    })
  }

  renderDateSetting () {
    let { ViewSetting } = this.state
    return (
      <Panel title={translation('14792')}>
        <Switch
          name='DateOnOrder'
          onChange={this.onChange}
          checked={!ViewSetting.DateOnOrder}
          labelText={translation('2221')}
          helpText={translation('15076')}
        />
      </Panel>
    )
  }

  renderTimeSetting () {
    let { ViewSetting } = this.state
    return (
      <Panel title={translation('14876')}>
        <Switch
          name='TimeOnOrderList'
          onChange={this.onChange}
          checked={ViewSetting.TimeOnOrderList}
          labelText={translation('15039')}
          helpText={translation('15077')}
        />
      </Panel>
    )
  }

  renderWorkscreen () {
    if (this.props.auth.departmentType !== 1) return null

    let { ViewSetting } = this.state
    return (
      <Panel title={translation('18')}>
        <LabelWrapper labelText={translation('16584')}>
          <Radio name='NewOrdersGrouping' value={0} checked={ViewSetting.NewOrdersGrouping === 0} onChange={this.onChange} labelText={translation('16585')} />
          <Radio name='NewOrdersGrouping' value={1} checked={ViewSetting.NewOrdersGrouping === 1} onChange={this.onChange} labelText={translation('16586')} />
        </LabelWrapper>
      </Panel>
    )
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    return (
      <div className='forsi__page'>
        <Row>
          <Col>
            {this.renderDateSetting()}
            {this.renderTimeSetting()}
            {this.renderWorkscreen()}
          </Col>
        </Row>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getViewSettings,
  saveViewSettings
})(ViewSettings)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/ViewSettings/index.js